import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { ClockHoursPipe } from './clock-hours.pipe';
import { MatInput } from '@angular/material/input';

const selector = 'automata-time-range-slider';
export const sleepTimeRangeStartHour = 'sleepTimeRangeStartHour';
export const sleepTimeRangeEndHour = 'sleepTimeRangeEndHour';

@Component({
  selector: 'automata-time-range-slider',
  template: `
    <glxy-form-row [formGroup]="form">
      <glxy-form-field [bottomSpacing]="bottomSpacing">
        <select matInput formControlName="sleepTimeRangeStartHour" matNativeControl>
          <option value="{{ startHour }}" disabled selected hidden>{{ startHour | clockHours: true }}</option>
          <option *ngFor="let hour of hours" [value]="hour">
            {{ hour | clockHours: true }}
          </option>
        </select>
      </glxy-form-field>
      <div class="time-range-divider">-</div>
      <glxy-form-field [bottomSpacing]="bottomSpacing">
        <select matInput formControlName="sleepTimeRangeEndHour" matNativeControl>
          <option value="{{ endHour }}" disabled selected hidden>{{ endHour | clockHours: true }}</option>
          <option *ngFor="let hour of hours" [value]="hour">
            {{ hour | clockHours: true }}
          </option>
        </select>
      </glxy-form-field>
    </glxy-form-row>
  `,
  styleUrls: ['./time-range-slider.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyInputModule,
    GalaxyFormFieldModule,
    MatSliderModule,
    ClockHoursPipe,
    MatInput,
  ],
})
export class TimeRangeSliderComponent implements OnInit {
  @Input() form?: FormGroup;
  sleepTimeRangeStartHourControl?: FormControl;
  sleepTimeRangeEndHourControl?: FormControl;

  @Input() startHour?: number;
  @Input() endHour?: number;

  @Input() bottomSpacing: 'default' | 'small' | 'none' | false = 'default';

  hours = Array.from({ length: 24 }, (_, i) => i);

  ngOnInit(): void {
    if (!this.form) {
      console.error(`${selector} cannot function without a form input`);
      return;
    }

    const startHour = this.startHour || 9;
    const endHour = this.endHour || 17;

    this.sleepTimeRangeStartHourControl = new FormControl(startHour);
    this.sleepTimeRangeEndHourControl = new FormControl(endHour);

    this.form!.addControl(sleepTimeRangeStartHour, this.sleepTimeRangeStartHourControl);
    this.form!.addControl(sleepTimeRangeEndHour, this.sleepTimeRangeEndHourControl);
  }
}
